module.exports = __webpack_public_path__ + "img/thumb5.58cab6ef.png";